import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';

import { IAbsenceBalanceDTO } from 'src/api/dtos';
import { IError } from 'src/api/types';

import { fetchAbsenceBalances } from './absenceBalance.actions';
import { IAbsenceBalancesState } from './absenceBalance.types';

const initialState: IAbsenceBalancesState = {
  data: [],
  loading: false,
  error: null,
};

export const absenceBalancesSlice = createSlice({
  name: 'absence-balances',
  initialState,
  reducers: {},
  extraReducers: (build) => {
    /* fetchAbsenceBalances */
    build.addCase(
      fetchAbsenceBalances.fulfilled.type,
      (state: Draft<IAbsenceBalancesState>, { payload }: PayloadAction<IAbsenceBalanceDTO[]>) => {
        return {
          ...state,
          data: payload,
          loading: false,
        };
      },
    );
    build.addCase(fetchAbsenceBalances.pending.type, (state: Draft<IAbsenceBalancesState>) => {
      return {
        ...state,
        error: null,
        loading: true,
      };
    });
    build.addCase(
      fetchAbsenceBalances.rejected.type,
      (state: Draft<IAbsenceBalancesState>, { payload }: PayloadAction<IError>) => {
        return {
          ...state,
          error: payload,
          loading: false,
        };
      },
    );
  },
});
